import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMenuGroup } from "src/models/Maintenance/MenuGroup.models";

interface MenuGroupState {
  menuGroups: IMenuGroup[];
  menuGroupToEdit: IMenuGroup | null;
}

const initialState: MenuGroupState = {
  menuGroups: [],
  menuGroupToEdit: null,
};

const menuGroupSlice = createSlice({
  name: "MenuGroup",
  initialState,
  reducers: {
    setMenuGroupList: (state, action: PayloadAction<IMenuGroup[]>) => {
      state.menuGroups = action.payload;
    },
    concatListMenuGroup: (
      state: MenuGroupState,
      action: PayloadAction<IMenuGroup[]>
    ) => {
      state.menuGroups = [...state.menuGroups.concat(action.payload)];
    },
    setMenuGroupToEdit: (state, action: PayloadAction<IMenuGroup | null>) => {
      state.menuGroupToEdit = action.payload;
    },
    addMenuGroup: (state, action: PayloadAction<IMenuGroup>) => {
      state.menuGroups.push(action.payload);
    },
    updateMenuGroup: (state, action: PayloadAction<IMenuGroup>) => {
      let itemIndex = state.menuGroups.findIndex(
        item => item.menuGroupId === action.payload.menuGroupId
      );
      if (itemIndex !== -1) state.menuGroups[itemIndex] = action.payload;
    },
    deleteMenuGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.menuGroups.filter(
        item => item.menuGroupId !== action.payload
      );
      state.menuGroups = newArray;
    },
  },
});

export const {
  setMenuGroupList,
  concatListMenuGroup,
  setMenuGroupToEdit,
  addMenuGroup,
  updateMenuGroup,
  deleteMenuGroup,
} = menuGroupSlice.actions;

export default menuGroupSlice.reducer;
